export default "__VITE_ASSET__BRtRubiT__"